import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () =>
    createStyles({
      container: {
        width: '100%',
      },
      title: {
        fontFamily: '"Exo 2"',
        fontSize: '26px',
      },
      contentText: {
        fontFamily: 'Nunito',
        fontSize: '16px',
        marginTop: 5,
      },
      content: {
        paddingTop: '4%',
        paddingLeft: '10%',
      },
      menuButton: {
        marginLeft: 0,
      },
    }),
  {
    name: 'NotFound',
  }
);
